var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NavigationBar_element;
/**
 * Navigation bar functionality
 * @class
 */
class NavigationBar {
    /**
     * @constructor
     * @param {HTMLElement} element The navigation bar root element
     */
    constructor(element) {
        _NavigationBar_element.set(this, void 0);
        __classPrivateFieldSet(this, _NavigationBar_element, element, "f");
        this.dropdowns = element.querySelectorAll("[data-component='Dropdown']");
        this.links = element.querySelectorAll("[data-component='DropdownLink']");
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.clearState = this.clearState.bind(this);
        this.links.forEach((link) => {
            link.addEventListener("click", this.toggleDropdown);
            link.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    this.toggleDropdown(event);
                }
            });
        });
    }
    toggleDropdown(event) {
        const el = event.target.closest("[data-component='DropdownLink']");
        const parentEl = el === null || el === void 0 ? void 0 : el.closest("[data-component='Dropdown']");
        if (parentEl) {
            const theParentEl = parentEl;
            const navLevel = theParentEl.dataset.navLevel;
            const targetEl = parentEl.querySelector("[data-component='DropdownNav']");
            if (!parentEl.classList.contains("is-active") && navLevel === 'secondary') {
                this.clearState("secondary");
            }
            else if (!parentEl.classList.contains("is-active") && navLevel === 'tertiary') {
                this.clearState("tertiary");
            }
            if (parentEl && targetEl) {
                parentEl.classList.toggle("is-active");
                targetEl.classList.toggle("is-visible");
            }
        }
    }
    clearState(navLevel) {
        this.dropdowns.forEach((link) => {
            var _a;
            const theLink = link;
            if (navLevel === theLink.dataset.navLevel) {
                link.classList.remove("is-active");
                (_a = link.querySelector(".is-visible")) === null || _a === void 0 ? void 0 : _a.classList.remove("is-visible");
            }
        });
    }
    close() {
        var _a;
        (_a = __classPrivateFieldGet(this, _NavigationBar_element, "f")) === null || _a === void 0 ? void 0 : _a.classList.remove('o-navigation-bar--opened');
        document.body.style.overflowY = 'visible';
        document.body.classList.remove('menu-open');
    }
    handleKeyUp(evt) {
        if ((evt === null || evt === void 0 ? void 0 : evt.key) === 'Escape') {
            this.close();
        }
        else {
            document.addEventListener('keyup', evt => this.handleKeyUp(evt), {
                once: true,
            });
        }
    }
    open() {
        var _a;
        (_a = __classPrivateFieldGet(this, _NavigationBar_element, "f")) === null || _a === void 0 ? void 0 : _a.classList.add('o-navigation-bar--opened');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('menu-open');
        this.handleKeyUp();
    }
    /**
     * Creates new instances of INavigationBarUtils for each `.o-navigation-bar` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const navigationBars = [...document.getElementsByClassName('o-navigation-bar')];
        navigationBars.forEach(navigationBar => {
            var _a, _b;
            const navigationBarUtil = new NavigationBar(navigationBar);
            (_a = navigationBar.querySelector('.o-navigation-bar__close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                navigationBarUtil.close();
            });
            (_b = navigationBar.querySelector('.o-navigation-bar__open')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
                navigationBarUtil.open();
            });
        });
    }
}
_NavigationBar_element = new WeakMap();
export default NavigationBar;
